import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-cancel",
  "use": "icon-icon-cancel-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-icon-cancel\">\r\n  <defs>\r\n    <style>\r\n      #icon-icon-cancel .cls-1 {\r\n        fill: #df5454;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-icon-cancel_路径_184\" data-name=\"路径 184\" class=\"cls-1\" d=\"M343.93,346.923a.123.123,0,0,0-.123-.123l-1.014,0-1.528,1.821-1.526-1.82-1.016,0a.122.122,0,0,0-.123.123.128.128,0,0,0,.029.08l2,2.382-2,2.38a.128.128,0,0,0-.029.08.123.123,0,0,0,.123.123l1.016,0,1.526-1.821,1.526,1.82,1.014,0a.122.122,0,0,0,.123-.123.128.128,0,0,0-.029-.08l-2-2.38,2-2.382A.123.123,0,0,0,343.93,346.923Z\" transform=\"translate(-335.265 -343.36)\" />\r\n  <path id=\"icon-icon-cancel_路径_185\" data-name=\"路径 185\" class=\"cls-1\" d=\"M70,65a6,6,0,1,0,6,6A6,6,0,0,0,70,65Zm0,10.982A4.982,4.982,0,1,1,74.982,71,4.983,4.983,0,0,1,70,75.982Z\" transform=\"translate(-64 -65)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-cancel.svg
// module id = arq5
// module chunks = 3